import { Component, Inject, PLATFORM_ID, AfterViewInit, OnDestroy } from '@angular/core';
import { NavBarComponent } from '../../shared/components/nav-bar/nav-bar.component';
import { RouterOutlet } from '@angular/router';
import { Router } from '@angular/router';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { ViewportScroller, isPlatformBrowser, DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-public-layout',
  imports: [RouterOutlet, NavBarComponent, FooterComponent],
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout-style.css']
})

export class PublicLayoutComponent implements AfterViewInit, OnDestroy {
  navbarVariant: 'default' | 'alt' = 'default';
  private resizeObserver: ResizeObserver | null = null;

  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.viewportScroller.setOffset(() => {
        const navbar = this.document.querySelector('.navbar');
        if (navbar) {
          return [0, Math.ceil(navbar.getBoundingClientRect().height)];
        }
        return [0, 0];
      });
    }

    this.router.events.subscribe(() => {
      if (this.router.url.includes('properties')) {
        this.navbarVariant = 'alt';
      } else if (this.router.url.includes('property')) {
        this.navbarVariant = 'alt';
      } else {
        this.navbarVariant = 'default';
      }
    });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      const navbar = this.document.querySelector('.navbar');
      if (navbar) {
        const updateHeight = () => {
          const height = Math.ceil(navbar.getBoundingClientRect().height);
          this.document.documentElement.style.setProperty('--dynamic-header-height', `${height}px`);
        };

        updateHeight();

        this.resizeObserver = new ResizeObserver(() => {
          updateHeight();
        });
        this.resizeObserver.observe(navbar);
      }
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId) && this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
